import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule
} from '@angular/material/dialog';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { HttpClient } from '@angular/common/http';
import { debounceTime, distinctUntilChanged, switchMap, of } from 'rxjs';
import { MatAutocompleteModule, MatAutocomplete, MatOption } from '@angular/material/autocomplete';
import { environment } from '../../../environments/environment';
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
  selector: 'app-prenotazione-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocomplete,
    MatOption,
    MatAutocompleteModule,
    MatProgressSpinner
  ],
  templateUrl: './prenotazione-dialog.component.html',
  styles: [`
    .w-100 { width: 100%; }
    mat-form-field { display: block; }
  `]
})
export class PrenotazioneDialogComponent {
  prenotazioneForm: FormGroup;

  filteredCf: string[] = [];
  isLoadingCf = false;

  // Regex standard per Codice Fiscale Italiano
  readonly cfRegex = /^[A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST][0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{3}[A-Z]$/i;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient, // Inietta HttpClient
    public dialogRef: MatDialogRef<PrenotazioneDialogComponent>,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.prenotazioneForm = this.fb.group({
      cf: ['', [Validators.required, Validators.pattern(this.cfRegex)]],
      note: ['']
    });

    // Logica di ricerca automatica mentre l'utente scrive
    this.prenotazioneForm.get('cf')?.valueChanges.pipe(
      debounceTime(300),        // Aspetta 300ms dall'ultimo tasto premuto
      distinctUntilChanged(),   // Procedi solo se il valore è cambiato
      switchMap(value => {
        if (value && value.length >= 3) { // Inizia a cercare dopo 3 caratteri
          this.isLoadingCf = true;
          const url = `${environment.API_ENDPOINT_COT_SERVICE}/search-cf?term=${value}`;
          return this.http.get<string[]>(url);
        } else {
          return of([]);
        }
      })
    ).subscribe({
      next: (res) => {
        this.filteredCf = res;
        this.isLoadingCf = false;
        this.cdr.markForCheck(); // Forza Angular a controllare i cambiamenti e mostrare il pannello
      },
      error: () => {
        this.isLoadingCf = false;
        this.cdr.markForCheck();
      }
    });
  }

  onAnnulla(): void {
    this.dialogRef.close();
  }

  onConferma(): void {
    if (this.prenotazioneForm.valid) {
      // Trasformiamo il CF in maiuscolo prima di inviarlo
      const formValue = this.prenotazioneForm.value;
      formValue.cf = formValue.cf.toUpperCase();
      this.dialogRef.close(formValue);
    }
  }
}